module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ABRIEL")]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("REPPI")])]), _vm._v(" stood outside the compact, ivy-clad Victorian house for a few minutes, his hands thrust into the pockets of his beaten suede jacket. He glanced up towards the left of the house, and saw that her room was in darkness. It would be. She would be at the stables now, even though it was after nine and the countryside was sunk in the frozen grip of winter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought of her brought a smile to his lips. For her, he would go through this, but it wouldn’t always be this way. He knew it. Could feel it in his bones. Knocking on the door of this house and being made to feel like a beggar, a distasteful presence to be endured by her parents with that particularly freezing politeness so typical of the British upper crust. No, things would change. He was only twenty-two and it might be a long haul, but things would change.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hardened his jaw and pressed his finger to the doorbell, listening to it resound through the house, then he lounged against the doorframe and waited until the door was cautiously pulled open. Gabriel was tempted to ask whether they were expecting bandits to ring the bell before entering the house, but he refrained. A keen sense of humour had never been one of Peter Jackson’s striking qualities, although that might just have been towards him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Greppi. What brings you here, boy?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabriel gritted his teeth together and summoned up all his self-control not to respond with something he would live to regret.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_vm._v("‘Could I have a word with you, Mr Jackson?’ He insin")]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("uated his foot through the small opening, just in case Peter Jackson gave in to the temptation to slam the door in his face.")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What, now? Can’t it wait?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Peter Jackson gave an impatient click of his tongue and regarded Gabriel’s dark, handsome face with irritation, then he reluctantly pulled open the door and stepped back. ‘If you’ve come to see my daughter, then you can start heading back to that house of yours, boy. Laura’s in bed and I have no intention of getting her out of it at this ungodly hour.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s nine o’clock.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Precisely.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And I haven’t come to see Laura, I have come to see you. You and your wife.’ Gabriel fought to maintain his composure but, under his weathered jacket and faded jeans, every muscle in his hard body had tensed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That stopped Peter Jackson in his tracks. He paused and narrowed his blue eyes. ‘I hope you don’t intend to ask any favours of me, boy, because I can tell you right now that the answer is a resounding negative. I am not in the habit of bailing out anyone financially.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have not come here to ask for money.’ He kept his tone as polite as he could, but the derision underneath was unmistakable and the older man’s mouth tightened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then say what you have to say and leave.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was turning out to be a big mistake. He had chosen to take the honourable path and now he wondered what had possessed him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Perhaps I could speak with your wife as well.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("‘Oh, very well. But you’ll have to be brief. My wife is not a well woman. She needs to get to bed at a reasonable hour.’ He turned and began walking towards the snug and ")]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Gabriel followed behind him, slightly taller and with the easy, graceful stride of someone attuned with his body.")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Lizzie, darling, we have an unexpected visitor. No, no need to get up. It’s just Greppi.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elizabeth Jackson sat in one of the big, padded armchairs, a fragile figure but with the stunning prettiness of a woman who even now, in her mid-fifties, could still make heads turn. The classic English rose who exuded good breeding from every one of her fingertips. Neither invited him to sit, nor was he offered a drink, although both were, he could tell, curious to find out what the hell he was doing in their house at the unseemly hour of nine in the evening.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Peter Jackson stood behind his wife’s chair, as ruggedly impressive as she was delicately pretty. ‘If you’re thinking of buying one of the horses, Greppi, then you’re out of luck. Laura tells me that you have a knack with Barnabus, but he’s not for sale. If you could afford him, which I frankly doubt. Might be a bit tempestuous, that stallion, but he’ll make a damned fine racehorse with the proper training, so don’t think you can cut yourself a deal cheaply simply because you know how to handle him. Or, for that matter, because my daughter chooses to associate with you. I am doing enough of a good deed by employing you to do odd jobs around the stables on the weekends.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have come to ask for your daughter’s hand in marriage.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I have come to tell you that I am from another planet. I have come to tell you that I am the son of Satan.")]), _vm._v(" Gabriel watched their astounded expressions and figured that he might as well have confronted them with either of those two possibilities.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("‘I know that Laura thinks the world of you both and I would very much like to receive your blessing.’ Gabriel’s ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("nerves remained steady as he stared at them both. Young he might be in years, but his life had not been an easy ride and he had learned to deal with pretty much anything that could be thrown at him. Including Laura’s snobbish, insular parents who had made it clear from the very first moment they had set eyes on him that he was one of life’s more lowly inhabitants.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I love your daughter, and whilst I realise that at the moment I may not have much to offer her, I assure—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That broke the gaping silence surrounding them. The mention of his penury. Peter Jackson flung back his head and roared with laughter, then he sobered up sufficiently to wipe a few residual tears of mirth from his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What, are you completely mad, Greppi? Now you listen to me and you listen carefully, boy.’ The older man leaned over his wife and enunciated his words very slowly, as if addressing someone whose grasp of English was faulty. ‘Neither Lizzie nor myself approved of your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("involvement")]), _vm._v(" with Laura, but she’s a big girl and there has not been much we could do about it. However, the only way you will marry our daughter is over my dead body! Do you read me loud and clear, boy? She is our jewel and there is no way on the face of this green earth that we will give our blessing to any marriage between the two of you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘She’s only a child, Gabriel.’ Elizabeth Jackson’s voice was quiet but firm. ‘Nineteen years old. And you’re only a child as well.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why don’t we cut through the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("child")]), _vm._v(" argument and get to the heart of the matter?’ Gabriel said with rigid self-control. ‘You see me as an inferior citizen because I am not British.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("‘That’s not true, young man!’ But Elizabeth Jackson’s protest was as empty as a shell. The truth was stamped on ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("her husband’s face and Gabriel turned his head to one side in anger.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You’re not what we have in mind for a son-in-law, Greppi. I have no doubt that you’ll make something of yourself, and good luck to you, but Laura deserves…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Better?’ Gabriel’s voice was spiked with acidity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Call it what you will. And I warn you, Greppi, you leave our daughter alone. We haven’t wanted to interfere, but you are no longer welcome at these stables. You can find somewhere else to do your riding and earn your extra money.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And that was the end of the discussion. Gabriel could see it in the way the old man turned towards the window, offering him the dismissive view of his back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Very well.’ Jet-black eyes smouldered as he looked at the two of them who would both breathe a sigh of heartfelt relief when he disappeared out of their line of vision.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But this was not over. He had appealed to them for their blessing and they had turned him down. Laura would not. He would have preferred to have married the woman he loved with her parents fully on his side, but if that was not to be the case, then so be it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned on his heel and walked out of the room, letting himself out of the front door. The meeting, which he had imagined would have lasted at least an hour, an hour of persuading them that, whatever their prejudices, he would devote his entire life to making their beloved daughter happy, had lasted a scant ten minutes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("The stables were set away from the house. Gabriel made sure to exit along the drive, knowing that her father would probably have leapt to the window just to make sure that he was leaving the premises, and, after a few minutes of walking through the cutting night air, he abruptly turned ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("to his right and ploughed his way back towards the extensive stables.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had arranged to meet her there and she would be waiting for him. The thought of that quelled some of the fire burning in his soul and he relaxed his pace, filling his head with images of her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The stables stretched around a huge courtyard, which was occasionally used for lessons for beginners. A long, sheltered corridor bordered the sprawling sweep of the individual horses’ quarters and Gabriel swiftly and assuredly made his way towards Barnabus’s stall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The light was on and she was grooming him, her long fingers stroking the mane, running along the proud length of his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabriel felt the familiar hot stirring in his loins and drew his breath in sharply, and both Laura and horse turned to look at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I didn’t expect you so early,’ she murmured, leaving the horse and wiping her hands along her jeans. She smiled and lifted her face to his, giving a soft purr of contentment as his mouth brushed hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Disappointed?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Hardly!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do you want me to give you a hand here?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, no. There’s nothing to be done. I was just chatting to Barnabus.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘About me, I hope,’ Gabriel murmured softly, pulling her towards him and keeping her there, with his hands on her rear, so that she could feel exactly what she did to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was the perfect combination of her parents. She had the height of her father and the blonde beauty of her mother. When she tilted her head back, as she was doing now, her waist-length hair rippled over his hands like strands of silk. White silk.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But of course,’ she agreed with a small laugh of delight. ‘Who else? What have you been doing since I last saw you? Have you missed me?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ve been slaving at an incompetently run engineering company. I’ve been poring over books so that I don’t completely lose track of my Economics degree. I’ve been putting aside every sweat-earned penny so that I can afford to eat when I return to university. Oh, yes, and I’ve asked your father for your hand in marriage and it was bitten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That little titbit, he decided, he would keep to himself. Now, he would lose himself in her and then he would propose. Her parents would simply have to accept him because they would have no choice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If you’re finished with Barnabus…’ he murmured, tucking her hair behind her ear and nibbling it with his teeth until she squirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The office…?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Out here, if you’d prefer, although I cannot truthfully say that I would welcome dealing with the frostbite afterwards…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The office comprised three rooms attached to the far end of the stables. One small sitting area for clients, a room in which the books were kept and a bathroom, all furnished with exquisite taste. Soon, Gabriel thought, they would no longer need to scurry and hide and make love like thieves in the night. He imagined her face as she heard him ask her to marry him and he felt a fierce quiver of possessiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What’s the matter?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned to see that she was staring up at him, all wide-eyed and concerned, and he smiled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("‘Do you ever dream of us making love in a proper bed?’ he asked softly, unlocking the door to the office with the ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("key that, unimaginatively, was hidden under one of the plant pots outside. He pushed open the door and then closed it behind them, capturing her against the back of the door and kissing the nape of her neck. ‘A proper, king-sized bed complete with satin sheets and a feather duvet?’")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘A cramped single bed would do,’ Laura murmured, sighing as his tongue trailed along her neck. ‘Anywhere but here. I have nightmares about Dad bursting in when we’re in the middle of…of…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Making love…?’ he finished smoothly for her and she coiled against him with a smile. His voice always did this to her, turned her legs to water. His dark, deep voice with the lingering traces of his Argentinian background, and his smoky, sexy eyes that could stroke her body even when he wasn’t touching her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("He had turned up out of the blue one wintry morning a year ago. One minute she had been bending over, grooming one of the horses, her long hair roughly braided back away from her face, and she had stood up to find him staring at her from the stable door, his hands in his pockets, his body leaning against the rough doorframe. He had heard about their stables and he had come to see whether he could earn some money helping out because he loved horses and was a natural at handling them. He had only just come up there to live. His father had been made redundant from his post as a teacher and, whilst he could cope until he located another job, there simply was no longer enough to cover his son’s university fees. Gabriel needed to work for a year and had taken a job nearby at a small company, interrupting his university career until he could accumulate sufficient money to put himself through the remainder of his course. He had explained all of this without taking his eyes off her and without moving from his indolent stance by the door. Laura had listened ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("and had hardly heard a word he had been saying. She had been too overwhelmed by his sheer animal beauty.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you suggesting that you want to make love to me?’ Gabriel whispered in her ear now, and Laura made a low, gurgling sound as he cupped her face in his hands and began kissing her jawbone with infinite, lingering tenderness. Underneath her three layers of clothing, she could already feel her breasts aching to be touched.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was dark in the office. Dark but warm, with the small fan heater gently purring like a soothing background noise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What would you do if I said that I just wasn’t in the mood?’ Laura teased, curling her fingers into his dark hair and nudging his face up so that she could cover his mouth with hers. The kiss was fiercely passionate, tongue pressing against tongue with an urgency that spoke volumes about the four days during which they had not seen one another. An eternity, it seemed to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I would call you a liar,’ he teased back. He slipped his hands beneath her thick, woollen jumper and hooked his fingers under the waistband of her jeans, then he gently circled his fingers round so that he could undo the button and slide down the zip, whilst Laura made a tiny moaning sound in anticipation of what was to come. Heaven on earth. It was the only way she could describe it. Sometimes when, for whatever reason, they had not managed to touch one another for a while, they would scrabble to make love, ripping each other’s clothes off in their eagerness to unite their bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tonight, Gabriel thought, was a special night. Tonight, they would take their time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("He led her towards the back of the office, where a long sofa was ranged against the wall. In the beginning, it had felt odd to make love in the place where Peter Jackson’s accountant did the books. Necessity, however, ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("was the mother of invention, and over time the oddness had faded away.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sofa could have been specially designed for coupling. Laura had once laughingly told him that, in her opinion, Phillip Carr had stationed it there so that when he came twice a week to do the accounts he had somewhere to nod off when the boredom of the numbers began to get to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Let me look at you,’ Laura said huskily, stretching her long body on the sofa and staring up at him as he towered over her. ‘You know I love looking at you get undressed.’ She loosely clasped her arms above her head so that a slither of flat, pale stomach was visible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have no idea why.’ He gave a low, teasing laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And who’s the liar now? You know exactly why I love looking at you. You have the most beautiful body I have ever set eyes on in my life. You’re as powerful and muscular as any one of our prized racehorses.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Thank you very much,’ he said drily, although he knew that, coming from her, this was the biggest compliment she could give him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged off his bomber jacket, then tugged his thick jumper over his head, followed by his tee shirt, once black, now faded to a dark, uneven grey.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Laura gave an involuntary groan of physical response at his bare-backed torso, just a shadowy outline in the darkness. She had seen him bare-backed before, though. In the summer, when he had stripped off his shirt and ridden Barnabus, without her father’s knowledge. Her memory could easily fill in the details of how he’d looked, his body bronzed, his muscles defined and rippling with every little movement. She watched, heavy-eyed, as he removed his trousers and the boxer shorts that were low slung on his waist, and her smile met his.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Enjoying the view?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Laura sighed with delicious assent and stood up, ready to wriggle out of her jeans. Her body was on fire. Just looking at him was enough to make her breathing shallow and unsteady.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Allow me, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("querida")]), _vm._v(",’ he murmured. It was one of the rare times when he uttered an endearment. He was a man of passion but essentially a controlled man. Outbursts of verbal emotion were not in his nature. No phoney declarations of love for him. Laura appreciated him for that. His tenderness went beyond mundane utterances. Which was why his endearment now made her heart flutter with pleasure. She allowed him to strip off her jumper, her long-sleeved rugby shirt, which had been a legacy from her father’s barnstorming days when he’d played rugby for the county, her tee shirt, leaving only her lacy bra, which barely covered the full swell of her generous breasts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Beautiful. You are exquisite.’ He dipped his finger into the hollow between her breasts and languidly stroked her, mesmerising her with his eyes until her breath caught in her throat. ‘I will never tire of looking at you, touching you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Laura laughed softly and caught his finger in her hand, raising it to her mouth so that she could draw it in between her lips, whilst she continued to look at him with her amazing chocolate-brown eyes. With her other hand, she lightly traced the hard muscles of his flattened stomach, down to where his manhood was sheathed with dark, vibrant hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v("? Even when you go to university in September to finish your course? And all those young, beautiful girls are there making eyes and flinging themselves at you?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("‘Would you be jealous?’ He slipped his hands down her waist and began easing her jeans off, tucking the tips of ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("his fingers into her briefs as she wriggled out of the jeans and gently kicked them to one side.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, absolutely, Gabriel. Which is why I don’t think about it.’ She licked his mouth with her tongue and pushed her body against his. She was only a few inches shorter than he was and their bodies made a perfect match, fitting against each other as though specifically designed for the purpose. ‘I prefer to concentrate on the here and now.’ To prove her point, she drew his hands down to the front of her briefs, wantonly offering him the temptation to explore the honeyed, womanly centre wetly waiting for his expert touch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You’re a witch, Laura.’ Gabriel tugged down her underwear and then unclasped her bra, allowing her full breasts with their rosy peaked nipples to spill forth in all their bountiful glory.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Only since I met you.’ And they both knew that that was true. She had come to him as a virgin, driven into his arms by a force of attraction she had never in her life experienced before. The many boys she had laughingly dated in the past had faded into insignificance alongside the potent, raven-haired stranger who had walked into her life and taken it over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Right answer.’ He cupped her breasts with his hands. God, he had meant for this to go oh, so slowly, but with her naked body pressing against his he had to fight to maintain control. When she rubbed against him as she was doing now, he just wanted to take her, to feel her body joined to his in heated, pulsating fulfilment.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("He guided her back to the sofa, but when she made to lie down he urged her back up, sitting, so that he could part her legs and kneel between them. The perfect position in which to devote his attention to her perfect breasts. He nuzzled them as Laura flung back her head and made no ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("effort to silence her groans of exquisite pleasure. His tongue played with the tips of her nipples and then his mouth circled first one, then the other, pulling and sucking until she began to buck gently against him with her hands firmly clasped in his hair.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No other man would ever touch her like this. She was his, he thought with a surge of possessive elation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He placed the flat of his hands against the soft inner flesh of her thighs and, whilst she was still reeling from the effects of his mouth on her sensitised breasts, he began a more intimate exploration that had her writhing and gasping as his tongue found the protruding nub of her femininity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In between her panting, he could hear the abandoned rawness of her voice as she verbalised her passion and that was a powerful aphrodisiac. With a final flick of his tongue deep into the moist sweetness, he rose up and thrust into her, moving strong and deep until their bodies reached the peak of mutual fulfilment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Only when they were physically spent did he shift her lengthways onto the sofa so that he could lie beside her. A tight fit but it felt so right with his leg draped over her body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Wouldn’t it be wonderful if we could actually fall asleep together, Gabriel? Like this? Spend the night together?’ Laura cradled his head against her breasts and smiled down at him. She swept some of her tangled hair away from her face and continued to watch him as he idly coiled one long, stray tendril around his finger. He held the hair between his fingers and languorously dangled it over her nipple until she giggled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("‘I could come and visit you when you’re at university,’ she carried on dreamily. ‘Your own room. Bliss. Or else you could come and visit me at university. Taking this year ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("off’s been good, but I can’t wait to stretch my wings and leave home.’")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Edinburgh is a long way to commute from London.’ He touched her nipple with the pad of his thumb and felt her body still under his touch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What are you saying to me, Gabriel?’ Laura jerked his head up so that their eyes met in the semi-darkness. ‘Too far to commute? I know it won’t be like it is now, with you working locally, but we’ll still see each other, won’t we? Fate brought us together. I know that. Why else would you have happened to see that advert for a job all the way up here, with lodgings provided? And why else would you have found your way here, at these stables, to earn some extra money, meeting me in the process? Fate.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah, but are you sure you will have time for me?’ he teased. ‘Studying to become a vet is not going to leave you much time for entertaining old…acquaintances…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Laura caught the wicked gleam in his eyes and breathed a silent sigh of relief.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So it’s just as well that you’re not an old acquaintance, isn’t it?’ She allowed herself a little laugh and relaxed back against the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" another solution, of course, to the problem of meeting up regularly…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, yes. What’s that?’ She ran one foot along the length of his thigh. ‘Have you suddenly discovered a vast sum of money somewhere and bought a helicopter so you can fly up to see me every evening?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Laura, will you marry me?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It took a few seconds for Laura’s drowsy brain to absorb what he had just said. ‘You’re joking, aren’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have never been more serious about anything in my life, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("querida")]), _vm._v(".’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Laura shifted herself into a sitting position and drew her ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("legs up. She desperately wanted to switch the light on so that she could see the expression on his face, but switching on lights was totally out of the question. The office block was not at all visible from the house, but it was still a chance they never took. Instead, she peered at him.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Marry you, Gabriel?’ He was deadly serious. His body language conveyed as much.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course, it would be a bit difficult to start with, but we could find somewhere cheap to rent in London and as soon as we are settled you could re-apply to a London university to do your course. Having to come up here to work and save money has slowed me down a bit, but I have only one year left to complete and then I will be earning money. We won’t go hungry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mi amor")]), _vm._v(", of that you can be certain.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Gabriel…’ Her voice was a low stammer as the implications of marrying him slammed into her like a fist. Her parents would die. Her mother certainly would. She knew that they had viewed her relationship with Gabriel with growing unease, and they probably weren’t even aware that they were lovers. Her mother had shown slightly more fortitude than her father and had contented herself with the occasional observations that she should be careful not to become too emotionally entangled. Her father had been more outspoken. He had told her only two weeks ago in no uncertain terms that he disapproved strongly of what was going on and that he wanted her to end any relationship before it got out of control.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She could feel him pulling away from her and she reached out and gripped his hand tightly. ‘God, Gabriel, I love you so much. I’ve never felt anything like this before. You know that. I’ve told you that a thousand times. More. But…’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("‘But…?’ No, this was not going how he’d imagined, not ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("at all. He had expected her immediate, glowing acceptance. Yes, there would be one or two problems, but nothing that could not be handled. Nothing that they could not discuss and solve. His pride began shifting into place. He could feel it closing around him like a vice and he took a few deep breaths to steady himself.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m only nineteen,’ she said, half pleading. ‘Can’t we just…carry on like this…?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You mean sneaking around your parents’ backs because you’re ashamed to be seen openly with me?’ he accused harshly, and Laura flinched back from the tone of his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’s unfair!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is it?’ He stood up and began putting on his boxer shorts, his jeans whilst she continued to watch him with a growing sense of panic. ‘It seems to me, Laura, that you don’t object to my presence in your bed, or should I say on this cursed sofa, but you object to it everywhere else in your life!’ Rage had now settled firmly into place. He remembered her father’s burst of laughter at the unimaginable idea that a poor Argentinian might want to marry his daughter and wondered whether it was so far removed from her own refusal. Because refuse she had. No point trying to cover it up in pretty packaging. She had turned him down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Stop it, Gabriel!’ She sprang to her feet, shaking with dismay, and tried to get his hands between hers, but he brushed them aside and carried on getting dressed whilst she stood before him in all her naked splendour. Her vulnerability only occurred to her when he had slung his tee shirt over him, and then she hurriedly began to follow suit, flinging on her clothes with shaking hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘God, you even still wear your father’s clothes!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("‘He doesn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wear")]), _vm._v(" this! And I only put it on because it’s ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("warm and it was the first thing that came to hand when I left the house tonight! Left the house "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to meet you")]), _vm._v("!’")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, under cover of darkness! Would you have been so desperate to come rushing out if I had invited you to dine with me? If you had been forced to tell "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mummy and Daddy")]), _vm._v(" that you were going on a date with me?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, I would have been just as desperate!’ Her eyes glittered with unshed tears, which she swallowed back. ‘But when have you ever asked me out on a date?’ she flung at him. ‘You come and work and sometimes we ride off together away from the house and we sleep together, but when have you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ever")]), _vm._v(" asked me to go out to dinner with you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You know the situation!’ His voice cut through her like a knife and sent a shiver of despair fluttering down her spine. ‘I have always made it clear that every meagre penny I get from the company is ploughed back into my bank account so that I can support myself financially for my last year at university!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ve")]), _vm._v(" offered to pay!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Accept money from a woman? Never.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Because you’re so damned proud! And you’re letting your pride destroy what we have now!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What we have? We have nothing.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The silence stretching around them was shattering. Gabriel could hardly look at her. His optimism as he had set off earlier for her house now seemed pathetic and absurd. Even after he had been kicked in the face by her parents, he had still stupidly convinced himself that she would still be his. His wife. He had made the classic mistake of avoiding reality, which was that she was rich and he was poor and never the twain could meet. Whatever flimsy objections she was now trying to come up with.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Don’t say that,’ Laura whispered. ‘I love you.’")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Just not enough to prove it. Just not enough to marry me. Words without action are meaningless.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You make it sound so simple, Gabriel. You love me, therefore do as I say and follow me to the ends of the earth, never mind about hurting anyone along the way.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He flushed darkly and his mouth tightened into a hard line. ‘It is as simple as you choose to make it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, it’s not! It’s anything "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but")]), _vm._v(" simple! What about my university degree?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I told you…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, that I could come to London and somehow it would all be sorted out! And my parents? Do I just walk away from them as well? Why can’t you just…wait? Wait for a few years? My parents would adjust over time…I know they would. I would be able to finish my degree. Perhaps I could start in Edinburgh and arrange a transfer…’ Her voice faltered into silence as she absorbed the hard expression on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I made a mistake.’ His mouth curled into a twisted smile that was the death knell on any lingering illusions she might have been nurturing that she could somehow prevent him from walking out of that door and never turning back. ‘I thought I knew you. I realise now that I never did.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You knew me, Gabriel. Better than anyone has ever known me,’ Laura intoned dully. One errant tear slipped out of the corner of her eye and she let it trickle down the side of her face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("‘Oh, I don’t think so, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("querida")]), _vm._v(".’ The endearment that had filled her with joy only an hour before was now uttered with sneering cynicism. ‘It’s time for you to get back to the playground you know best. You will go to university and be the golden girl your mummy and daddy have ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("trained you to be and then, in time, you will marry someone they approve of and live happily ever after.’")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned away and began walking towards the door and that snapped her out of her daze and she rushed behind him, past him so that she could position herself in front, blocking his way out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Don’t do this!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Get out of my way.’ There was a grim determination in his voice but Laura stood her ground, refusing to watch him leave even though her head was screaming at her that it was all over and that there was nothing she could do to make him stay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It flew through her head that she could agree to marry him. Marry him and crash headlong into her parents’ disappointment and anger. Toss aside her aspirations and follow him, as he wanted, to the ends of the earth. But the moment was lost when she realised, knowing it to be a fact, that he would never accept her now. All those little indications of his pride that she had glimpsed over the months had solidified into something she could not breach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt an anger rise inside her suddenly. ‘If you loved me, you would wait for me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He reached out and pulled the door open from behind her and, tall though she was, she was not half as powerful as he was. He opened it easily, sending her skittering out of his path.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It can’t end like this,’ Laura cried desperately. Her flash of self-righteous anger had lasted but a second before disappearing in a puff of smoke. ‘Tell me that we’ll meet again.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He paused and looked at her then. ‘You should hope, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("querida")]), _vm._v(", that we never do…’")])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-392ee21a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426883279_ch01.vue
// module id = 69
// module chunks = 0